// extracted by mini-css-extract-plugin
export default {"ManagerMobilePage":"ManagerMobilePage_ManagerMobilePage__CxXJq","MobileBanner":"ManagerMobilePage_MobileBanner__PKIm5"};